export default __webpack_public_path__ + "static/wordpress_lshs-a1747b8075bb426a14cbbec008f1f7e2.svg";